export default __webpack_public_path__ + "static/cmp_pageheading-37941e46683532b8c37d623ce10c3038.jpg";